export function getManipulatorCompanyVacancies (state) {
  return state.companyVacancies
}
export function getManipulatorFirstCompany (state) {
  return state.company
}

export function getManipulatorCompanies (state) {
  return state.companies
}
export function getRecruitedResumes (state) {
  return state.recruitedResumes
}

export function getRecruitedResume (state) {
  return state.recruitedResume
}

export function getUserData (state) {
  return state.userData
}

export function getToken (state) {
  return state.token
}



// WEBPACK FOOTER //
// ./src/vuex/manipulators/getters.js